<!--  -->
<template>
    <div class='e-plan'>
        <p class="plan-title">画面管理
            <i class="el-icon-circle-plus scene-btn" style="cursor: pointer;float: right;margin-top: 5px;font-size: 18px;" @click="editSence({})"></i>
        </p>
        <div class="plan-list">
            <ul class="sence-list">
                <template v-for="(v, i) in scenes">
                    <li class="sence-item" :key="v.oid" :class="[index === i ? 'active' : '']">
                        <span class="item-title" @click="choseSence(v, i)">{{v.serverroom_map_name}}</span>
                        <span class="item-icon" @click="editSence(v)">
                            <i class="el-icon-edit"></i>
                        </span>
                        <span class="item-icon" @click="deleteSence(v)">
                            <i class="el-icon-delete"></i>
                        </span>
                    </li>
                </template>
            </ul>
        </div>
        <p class="plan-title">元件</p>
        <div class="plan-list">
            <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item title="基本" name="1">
                    <div class="img-list">
                        <template v-for="v in basePlan">
                            <div class="item" :key="v.id" :data-type="v.type"
                                @dragstart="dragstart(v)" :draggable="v.isDarg" @drag='draging' @dragend="dragend">
                                <img :src="v.icon" alt="">
                                <span>{{v.name}}</span>
                            </div>
                        </template>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="设备" name="2">
                   <template v-for="v in devciePlan">
                        <div class="item" :key="v.id" :data-type="v.type" 
                            @dragstart="dragstart(v)" :draggable="v.isDarg" @drag='draging' @dragend="dragend">
                            <img :src="v.icon" alt="">
                            <span>{{v.name}}</span>
                        </div>
                    </template>
                </el-collapse-item>
                <el-collapse-item title="管道" name="3">
                    <template v-for="v in pipePlan">
                        <div class="item" :key="v.id" :data-type="v.type"
                            @dragstart="dragstart(v)" :draggable="v.isDarg" @dragover="dragover" @drag='draging' @dragend="dragend">
                            <img :src="v.icon" alt="">
                            <span>{{v.name}}</span>
                        </div>
                    </template>
                </el-collapse-item>
                <el-collapse-item title="其他" name="4">
                   
                </el-collapse-item>
            </el-collapse>
        </div>

        <!-- 添加弹框 -->
        <cmp-scene-dialog :visible="visible" :form="itemData" @handleCloseDialog="handleCloseDialog"></cmp-scene-dialog>
    </div>
</template>

<script>
import cmpSceneDialog from './cmpSceneDialog'
import constConfig from '@/config/constConfig.js'
import Service from '@/api/Service'
import { $Alert } from '@/utils/utils'
import bus from "@/utils/bus";
import { Loading } from 'element-ui';

export default {
    name:  'eplan',
    props: {
        dragGroup: {
            type: Object,
        }
    },
    components: { cmpSceneDialog },
    data() {
        return {
            activeNames: ['1', '2', '3'],
            basePlan: constConfig.basePlan,
            devciePlan: constConfig.devciePlan,
            pipePlan: constConfig.pipePlan,

            scenes: [],
            index: 0,

            visible: false,
            itemData: {},
        };
    },

    mounted() {
        bus.$on('save', async ()=>{
            let loadingInstance = Loading.service({ fullscreen: true });
            let svgData = this.dragGroup.svg()
            let params = this.scenes[this.index]
            params.map_value_computer = svgData
            params.map_type = 2
            let res = await Service.editMapServerroom(params)
            loadingInstance.close();
            if(res) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
            }
        })
        this.$nextTick(()=>{
            this.getData()
        })
    },

    created() {
        
    },

    methods: {
        async getData() {
            let res = await Service.getServerroombypid();
            res = res === 'success' ? [] : res
            if(res.length>0) {
                this.scenes = res;
                this.$emit("changeSence", this.scenes[0]);
            }else{
                this.$emit("changeSence", null);
            }
        },
        handleChange(val) {
            
        },
        dragstart(data) {
            try {
                // IE只允许KEY为text和URL
                event.dataTransfer.setData('data', JSON.stringify(data))
            } catch (ex) {
                console.log(ex)
            }
        },
        draging(e) {
            // 拖动中
            
        },
        dragover(e) {
            e.preventDefault();
        },
        dragend(event) {
            event.dataTransfer.clearData()
        },
        choseSence(v, index){
            this.index = index;
            this.senceData = v.map_value_computer
            this.$emit("changeSence", v);
        },
        editSence(v) {
            this.visible = true;
            this.itemData = v;
        },
        deleteSence(v) {
            $Alert(`是否确认删除 ${v.serverroom_map_name} `).then( async (bool)=>{
                if(bool){
                    let res = await Service.deleteMapServerroom({oid: v.oid});
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getData();
                    }
                }
           });
        },
        // 新增弹框
        handleCloseDialog(data) {
            this.visible = false;
            if(data.flag) {
                this.getData();
            }
        },
    }
}

</script>
<style lang='less' scoped>
    .e-plan{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        z-index: 99;
        width: 220px;
        background-color: #fff;
        overflow-y: auto;
        .plan-title{
            height: 28px;
            padding: 0 10px;
            background-color: #f4f4f4;
            line-height: 28px;
            color: #666;
            font-size: 14px;
            font-weight: 400;
            text-align: center;
            .scene-btn:hover{
                color: #266cba;
            }
        }
        .plan-list{
            -ms-touch-action: none;
            touch-action: none;
            overflow: hidden;
            font-size: 0;
            .item{
                display: inline-block;
                width: 50px;
                padding: 1px;
                font-size: 12px;
                background-repeat: no-repeat;
                background-position: 50% 50%;
                border: 1px solid transparent;
                border-radius: 2px;
                text-align: center;
                vertical-align: middle;
                cursor: move;
                img{
                    width: 40px;
                    height: 40px;
                    display: block;
                    margin: 0 auto;
                }
            }
        }
    }
    .sence-list{
        margin-bottom: 30px;
        .sence-item{
            padding: 0 10px;
            line-height: 32px;
            height: 32px;
            display: flex;
            flex-direction: row;
            border-bottom: 1px solid #ccc;
            span{
                font-size: 12px;
            }
            .item-title{
                flex: 1;
                cursor: pointer;
            }
            .item-icon{
                display: inline-block;
                width: 28px;
                height: 32px;
                text-align: center;
                line-height: 32px;
                margin-right: 5px;
                cursor: pointer;
                &:hover{
                    i{
                        color: #266cba;
                    }
                }
            }
            &.active{
                background-color: #266cba;
                color: #fff;
                &:hover{
                    i{
                        color: #fff;
                    }
                }
            }
        }
    }
</style>